// src/components/TagGroup.jsx
import React from "react";
import Tag from "./Tag";

const TagGroup = ({ tags }) => {
  return (
    <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
      {tags.map((tag, index) => (
        <Tag
          key={index}
          label={tag.label}
          color={tag.color}
          textColor={tag.textColor || "#fff"}
        />
      ))}
    </div>
  );
};

export default TagGroup;
